import React from 'react';
import { useTheme } from 'styled-components';

import { BaseButton } from '../BaseButton/BaseButton';
import { Size } from '../constants';
import type { OriginalButtonProps, OriginalLinkProps } from '../types';
import { Variant } from './constants';
import type { ButtonProps } from './types';
import { getPrimaryColors, getSecondaryColors, getVariantColors } from './utils';

export const Button = ({
  variant = Variant.ACTION,
  StartIcon,
  children,
  loading = false,
  size = Size.MEDIUM,
  width = 'fit-content',
  height = 'fit-content',
  dataCy,
  ellipsis = false,
  textRef,
  ...buttonProps
}: ButtonProps) => {
  const props = buttonProps as OriginalLinkProps | OriginalButtonProps;
  const { color } = useTheme();

  return (
    <BaseButton
      StartIcon={StartIcon}
      variant={
        variant === Variant.STROKE
          ? BaseButton.Variant.STROKE
          : BaseButton.Variant.BACKGROUND
      }
      primaryColor={getVariantColors(variant, getPrimaryColors(color))}
      secondaryColor={getVariantColors(variant, getSecondaryColors(color))}
      loading={loading}
      size={size}
      height={height}
      width={width}
      dataCy={dataCy}
      ellipsis={ellipsis}
      textRef={textRef}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {children}
    </BaseButton>
  );
};

Button.Variant = Variant;
Button.Size = Size;
